// extracted by mini-css-extract-plugin
module.exports = {"categories-subCategories-container":"CategoriesAndSubCategories_categories-subCategories-container__1fZJE","heading":"CategoriesAndSubCategories_heading__1bl-x"};